import { Component, OnInit, Input } from '@angular/core';
import { URLSearchParams } from '@angular/http';

import { Modal, BSModalContext } from 'angular2-modal/plugins/bootstrap';
import { overlayConfigFactory } from 'angular2-modal';

import { HackResultModalComponent } from '../../../shared/modals/hack-result/hack-result-modal.component';

import { AuthService } from '../../../../../providers/auth.service';
import { SharedHackService } from '../../../shared/services/shared-hack.service';
import { SharedClientService } from '../../../shared/services/shared-client.service';
import { ScreenTalentService } from '../../screen-talent.service';

import { default as swal } from 'sweetalert2';


export class CompletedComponent implements OnInit {

	 public test: any;

	public candidates: any[];
	public clientBilling: any;
	public hasAvailableSlots: boolean = false;
	public offset = 0;
	public size = 10;
	public state: any = {
		loading: false,
		hasMore: true,
		count: 0
	};

	constructor(
		public modal: Modal,
		private authService: AuthService,
		private sharedHackService: SharedHackService,
		private sharedClientService: SharedClientService,
		private screenTalentService: ScreenTalentService) { }

	// Lifecycle Events
	public ngOnInit(): void {
		this.getCandidatesCount();
		this.getCandidates(false);
		this.getClientCurrentBilling();
		this.getBillingCreditAvailability();
	}

	// Events
	public onViewFullAnswersClick(candidate: any): void {
		if (!candidate.external_test || !candidate.external_test.hack || (!this.hasAvailableSlots && !candidate.unlocked)) {
			return;
		}

		if (this.hasAvailableSlots && !candidate.unlocked) {
			swal({
				title: '',
				text: 'Are you sure you want to use a credit to see the answers?',
				type: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#E06160',
				confirmButtonText: 'Yes',
				cancelButtonText: 'No',
				allowOutsideClick: false,
				allowEscapeKey: false,
				reverseButtons: true
			}).then(() => {
				this.openHackModal(candidate);
			}, () => undefined);
		} else {
			this.openHackModal(candidate);
		}
	}

	// Service Call
	private getCandidatesCount(): void {
		let queryParams = new URLSearchParams();
		queryParams.set('status', 'completed');

		this.sharedHackService.getExternalTestInvitationsCount(String(this.authService.userId), this.test.id, queryParams).subscribe(
			(stats) => {
				this.state.count = stats.total;
				this.screenTalentService.emitEventAction({ component: 'screen-talent', action: 'updateCompletedCandidatesCount', data: this.state.count });
			}
		);
	}

	private getClientCurrentBilling(): void {
		this.state.loading = true;

		this.sharedClientService.getCurrentBilling(String(this.authService.userId)).subscribe(
			(billing) => {
				this.clientBilling = billing;
			}
		);
	}

	private getBillingCreditAvailability(): void {
		this.sharedClientService.checkProductTemplateCreditAvailability(String(this.authService.userId), 'assessment-slots').subscribe(
			(availability) => {
				this.hasAvailableSlots = availability;
			}
		);
	}

	private getCandidates(concat?: boolean): void {
		this.state.loading = true;

		let queryParams = new URLSearchParams();
		queryParams.set('status', 'completed');

		if (!concat) {
			queryParams.set('limit', String(this.offset + this.size));
			queryParams.set('offset', String(0));
		} else {
			queryParams.set('limit', String(this.size));
			queryParams.set('offset', String(this.offset));
		}

		this.sharedHackService.getExternalTestInvitations(String(this.authService.userId), this.test.id, queryParams).subscribe(
			(candidates) => {
				this.candidates = this.candidates || [];
				this.candidates = concat ? this.candidates.concat(candidates) : candidates;
				this.state.hasMore = (candidates.length % this.size) === 0;

				this.state.loading = false;
			}
		);
	}

	private openHackModal(candidate: any): void {
		let modalSettings: any = {
			isBlocking: true,
			size: 'lg',
			initData: {
				candidateId: candidate.candidate_id,
				candidateUuid: candidate.candidate.uuid,
				hackId: candidate.external_test.hack.hack_id
			}
		};
		this.modal.open(HackResultModalComponent, overlayConfigFactory(modalSettings, BSModalContext))
			.then((result) => {
					result.result.then(
						(response) => {
							this.getCandidates(false);
							this.getBillingCreditAvailability();
						},
						() => {
							this.getBillingCreditAvailability();
						});
				}
			);
	}

	// Helpers

	private onLoadMoreClick(): void {
		this.offset += this.size;
		this.getCandidates(true);
	}
static ctorParameters() { return [ { type: Modal }, { type: AuthService }, { type: SharedHackService }, { type: SharedClientService }, { type: ScreenTalentService } ]; }}



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/components/client/screen-talent/test/completed/completed.component.ts